import {Component, h, Prop} from '@stencil/core';

type GapWrapper = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12';

/**
 * @part flex-parent - element inside the shadow DOM that sets the display: flex rule.
 */
@Component({
    tag: 'joy-wrapper',
    styleUrl: './wrapper.scss',
    shadow: true,
})
export class JoyWrapper {
    /** CSS rule for flex justify-content.  **/
    @Prop({reflect: true}) justify: 'center' | 'space-between' | 'flex-start' | 'flex-end' = 'flex-start';
    /** CSS rule for flex align-items.  **/
    @Prop({reflect: true}) align: 'center' | 'flex-start' | 'flex-end' | 'stretch' = 'center';
    /** CSS rule for flex direction  **/
    @Prop({reflect: true}) direction: 'row' | 'column' = 'row';
    /** CSS rule for flex wrap  **/
    @Prop({reflect: true}) wrap: 'nowrap' | 'wrap' = 'wrap';
    /** Bottom margin for the wrapper.  **/
    @Prop({reflect: true}) noMargin = false;
    /** CSS rule for flex row gap. Value is based on spacing tokens */
    @Prop({reflect: true}) rowGap: GapWrapper = '8';
    /** CSS rule for flex column gap. Value is based on spacing tokens */
    @Prop({reflect: true}) columnGap: GapWrapper = '4';

    render() {
        return (
            <div
                part="flex-parent"
                class={{
                    'joy-wrapper': true,
                    [`joy-wrapper--justify-${this.justify}`]: true,
                    [`joy-wrapper--align-${this.align}`]: true,
                    [`joy-wrapper--direction-${this.direction}`]: true,
                    [`joy-wrapper--wrap-${this.wrap}`]: true,
                    [`joy-wrapper--row-gap-${this.rowGap}`]: true,
                    [`joy-wrapper--column-gap-${this.columnGap}`]: true,
                    'joy-wrapper--has-margin': !this.noMargin,
                }}
            >
                <slot />
            </div>
        );
    }
}
